/**
 * <SmartImg /> — picks an optimized WebP thumb on small viewports
 * and falls back to the full JPG on larger screens. Uses the
 * <picture> element so the browser downloads only one source.
 *
 * Convention:
 *   src = "/dishes/gilda-X.jpg"       (full)
 *   thumb derived = "/dishes/thumbs/gilda-X.webp"
 *
 * If a thumb does not exist, pass `noThumb` to force the JPG only.
 */
export default function SmartImg({
  src,
  alt = '',
  loading = 'lazy',
  className,
  noThumb = false,
  thumbBreakpoint = '(max-width: 768px)',
  ...rest
}) {
  if (noThumb || !src.startsWith('/dishes/')) {
    return <img src={src} alt={alt} loading={loading} className={className} {...rest} />;
  }
  const thumb = src.replace('/dishes/', '/dishes/thumbs/').replace(/\.(jpg|jpeg|png)$/i, '.webp');
  return (
    <picture>
      <source srcSet={thumb} type="image/webp" media={thumbBreakpoint} />
      <img src={src} alt={alt} loading={loading} className={className} {...rest} />
    </picture>
  );
}
